<template>
  <div style="padding: 16px 0 16px 16px">
    <Spin fix v-show="loading">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>正在获取拉取镜像任务列表</div>
    </Spin>
    <span style="font-weight: bold; margin-right: 10px">镜像拉取任务列表</span>
    <a style="text-align: right" v-on:click="getTasks(nodes)">
      <Icon type="md-refresh" size="16" />
    </a>
    <Divider style="margin: 16px 0;"/>
    <CellGroup>
      <Alert show-icon type="warning" style="margin: 0 5px;" v-if="error">获取任务列表失败</Alert>
      <div v-else :style="{maxHeight: height}" class="container-image-pull-task-cell">
        <Cell v-for="item in tasks" :key="item.id" :name="item.id" style="padding: 0;">
          <Tooltip transfer>
            <a style="word-wrap:break-word">{{ item.repository }}:{{ item.tag }}</a>
            <div slot="content">
              <p>节点：{{ item.node.name }}</p>
              <p>状态：<span :style="{color: item.status === 'FAILURE' ? 'red' : item.status === 'SUCCESS' ? '#19be6b' : ''}">{{ item.status }}</span></p>
              <pre v-if="item.status === 'FAILURE'"><span style="color: red">错误</span>：{{ item.error }}</pre>
              <p>用户：{{ item.user.name ? item.user.name : item.user.username }}</p>
              <p v-if="item.created_at">开始：{{ moment(item.created_at).format('YYYY-MM-DD HH:mm:ss') }}</p>
              <p v-if="item.finished_at">结束：{{ moment(item.finished_at).format('YYYY-MM-DD HH:mm:ss') }}</p>
            </div>
          </Tooltip>
          <Badge status="success" slot="extra" v-if="item.status === 'SUCCESS'" />
          <Badge status="error" slot="extra" v-else-if="item.status === 'FAILURE'" />
          <Badge status="processing" slot="extra" v-else />
        </Cell>
      </div>
    </CellGroup>
  </div>
</template>

<script>
import { getImagePullTasks } from '@/api/container/image'
import moment from 'moment'

export default {
  name: 'image-pull-tasks',
  data () {
    return {
      tasks: [],
      error: false,
      loading: false,
      nodes: [],
      moment: moment,
      height: ''
    }
  },
  created () {
    window.addEventListener('resize', this.getHeight)
    this.getHeight()
  },
  methods: {
    getTasks (nodes) {
      this.nodes = nodes
      this.loading = true
      getImagePullTasks({nodes: this.nodes}).then(res => {
        this.tasks = res.data
        this.loading = false
        this.error = false
      }).catch(res => {
        this.error = true
        this.loading = false
        console.log(res.response)
      })
    },
    getHeight () {
      this.height = window.innerHeight - 170 + 'px'
    }
  }
}
</script>

<style lang='scss' scoped>
  .demo-spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
  }
  @keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
  }
  .demo-spin-col{
    height: 100px;
    position: relative;
    border: 1px solid #eee;
  }
  pre {
    white-space: pre-wrap;
    word-wrap: break-word;
  }
  .container-image-pull-task-cell {
    padding: 0;
    overflow-y: auto;
    height: auto;
    padding-bottom: 5px;
  }
  .container-image-pull-task-cell::-webkit-scrollbar {
    width: 5px;
  }
  .container-image-pull-task-cell::-webkit-scrollbar-track {
    border-radius: 5px;
    background-color: #eee;
  }
  .container-image-pull-task-cell::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #dbdbdb;
  }
</style>
